import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

export const StyledDialog = withStyles({
  paper: {
    margin: 0,
  },
  paperFullScreen: {
    margin: 0,
    height: '100%',
    backgroundColor: 'white',
  },
  paperWidthLg: {
    maxWidth: '100%',
  },
  scrollPaper: {
    alignItems: 'center',
  },
  paperFullWidth: {
    width: '100%',
  },
})(Dialog);

export const StyledDialogEdit = withStyles({
  paper: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
  },
  paperFullScreen: {
    margin: 0,
    height: '100%',
    backgroundColor: 'white',
  },
  paperWidthLg: {
    maxWidth: '100%',
  },
  scrollPaper: {
    alignItems: 'center',
  },
  paperFullWidth: {
    width: '100%',
  },
  container: {
    height: 'auto',
  },
})(Dialog);

export const Accordion = withStyles({
  root: {
    margin: '0',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
      padding: 0,
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionDetails = withStyles({
  root: {
    padding: 0,
  },
})(MuiAccordionDetails);

export const AccordionSummary = withStyles({
  root: {
    height: 40,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0px 0px',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const WarningIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ position: 'relative', top: 4, right: 2 }}
  >
    <circle r="6" transform="matrix(1 0 0 -1 8 8)" stroke="#E01919" />
    <circle r="1" transform="matrix(1 0 0 -1 8 11)" fill="#E01919" />
    <path
      d="M7.5 5C7.5 4.72386 7.72386 4.5 8 4.5C8.27614 4.5 8.5 4.72386 8.5 5L7.5 5ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8L8.5 8ZM8.5 5L8.5 8L7.5 8L7.5 5L8.5 5Z"
      fill="#E01919"
    />
  </svg>
);
